import { IAuctionState, IAuctionStrategy } from './types';

export const defaultStrategy: IAuctionStrategy = {
  isEnabled: false,
  serviceTypes: [],
  strategyName: '',
};

export const defaultState: IAuctionState = {
  isEnabled: false,
  isBetChanged: false,
  currentBet: 0,
  minimalBet: 0,
  maximalBet: 0,
  nextBets: [],
  previousBets: [],
  configurations: {},
  incompatibleServices: [],
  period: null,
  serviceCosts: [],
  strategy: defaultStrategy,
};
